// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1gOmg","right":"styles_right__c_Z9t"};